import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { PART_ID } from "MODULES/inventories/constants";
import api from "APP_ROOT/api";
import Form from "./Form";

export default function AssignToExchange({ editing, close, inventory }) {
  const partId = inventory.get(PART_ID);
  const [lineItems, setLineItems] = useState([]);

  useEffect(
    () => {
      api.purchaseOrderLineItems.assignableExchangeSearch().then(({ data }) => {
        setLineItems(data.results);

        return function cleanup() {};
      });
    },
    [partId]
  );
  return (
    <Modal open={editing} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Assign As Core Return</h4>
      </Header>
      <Form
        close={close}
        enableReinitialize
        partId={partId}
        lineItems={lineItems}
      />
    </Modal>
  );
}

AssignToExchange.propTypes = {
  inventory: PropTypes.shape({}),
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/AssignToExchange/AssignToExchange.jsx